import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setCategoryName } from 'src/features/selfAssessment/selfAssessmentSlice';
import { useAppDispatch } from 'src/app/hooks';

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setCategoryName(''));
    window.scrollTo(0, 0);
  }, [pathname, dispatch]);

  return null;
}
